module.exports = __webpack_public_path__ + "f90911d600a7c2314acc455893de485a.fbx";